import { render, staticRenderFns } from "./DxViewWorkOrderEmployeeTable.vue?vue&type=template&id=354b4d66&"
import script from "./DxViewWorkOrderEmployeeTable.vue?vue&type=script&lang=js&"
export * from "./DxViewWorkOrderEmployeeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports